import { centsToDollars } from '../formatters/numbers.js';
import { getCookie } from '../cookies';

/**
 * @typedef {object} AwinAffiliateInfo
 * @property {string} tt - tracking type. 'ss' for server to server
 * @property {number} tv - tracking version (2)
 * @property {number} amount - the amount of the order in dollars
 * @property {string} ch - 'aw' if awin is the last click referrer; 'other' or undefined otherwise
 * @property {string} parts - For commission splitting; 'default:amount' for all commissions to go to default
 * @property {string} cr - currency; 'USD'
 * @property {string} ref - the wb order id
 * @property {string} testmode - '1' for test mode, '0' for production
 * @property {string} cks - the awc value from the ad link. (we capture this from an ad link query param in an awin_awc cookie)
 */

/**
 *
 * @param {string|number} orderId - the order id
 * @param {number} amountCents - the amount of the order in cents
 * @param {boolean} testMode - true for awin testing
 * @returns {AwinAffiliateInfo}
 */
export function awinAffiliateInfo(orderId, amountCents = 0, testMode) {
  const amount = centsToDollars(amountCents);
  return {
    tt: 'ss',
    tv: 2,
    amount,
    ch: getCookie('awin_channel') || getCookie('AwinChannelCookie'),
    parts: `default:${amount}`,
    cr: 'USD',
    ref: orderId,
    testmode: testMode ? '1' : '0',
    cks: getCookie('awin_awc') || getCookie('_aw_sn_41892'),
    // vc: {{vouncher_code}}
  };
}
